import angular from 'angular';

const subPages = [
  require('./bulk-import/_index'),
  require('./caption-editor/_index'),
  require('./channels/_index'),
  require('./contributors/_index'),
  require('./embed/_index'),
  require('./events/_index'),
  require('./extended-test/_index'),

  require('./home/_index'),
  require('./logout'),
  require('./marketing-corner/_index'),
  require('./multi-site/_index'),
  require('./navbar/_index'),
  require('./new-event/_index'),
  require('./reports/_index'),
  require('./resources/_index'),
  require('./settings/_index'),
  require('./sources/_index'),
  require('./switcher-studio/_index'),
  require('./uploads/_index'),
  require('./complete-migration/_index'),
  require('./checkout/_index'),
];

let module = angular.module(
  'app.pages',
  subPages.map((s) => s.default.name)
);

export default module;



// WEBPACK FOOTER //
// ./app/pages/_index.js